export default __webpack_public_path__ + "static/s-section-img-1e1906fe29cb08c43d495ec79bd13a03.png";